import { Controller } from "stimulus";
import $ from "jquery";

export default class extends Controller {
  static targets = ["panel"];
  static values = {
    delay: Number,   // how long before showing (ms)
    expiry: Number   // how long to suppress after close (ms)
  };

  connect() {
    // Key in localStorage
    this.storageKey = "kidlinksPopup";

    // If closed recently, do nothing
    const closedAt = parseInt(localStorage.getItem(this.storageKey), 10);
    if (closedAt && (Date.now() - closedAt) < this.expiryValue) {
      return;
    }

    // Otherwise schedule pop‑up
    this.timeout = setTimeout(() => {
      $(this.panelTarget).fadeIn();
    }, this.delayValue);
  }

  close() {
    // Cancel pending show and hide immediately
    clearTimeout(this.timeout);
    $(this.panelTarget).fadeOut();

    // Remember close time
    localStorage.setItem(this.storageKey, Date.now().toString());
  }
}
